var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import unboxingDryIceGifSrc from '@images/onboarding/unboxing_dry_ice.gif';
import Header from '@marketing/components/funnel/Header';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Outlet, ScrollRestoration, useLoaderData, useLocation } from 'react-router';
import { ProfileProvider } from './ProfileContext';
var ProfileLayout = function () {
    var data = useLoaderData();
    var location = useLocation();
    if (window.useOldFunnel) {
        window.location.reload();
        return _jsx(_Fragment, {});
    }
    return (_jsxs(HelmetProvider, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: "Profile | Nom Nom Sign Up" }), _jsx("link", { rel: "canonical", href: "https://nomnomnow.com".concat(location.pathname) })] }), data ? (_jsxs(ProfileProvider, __assign({ initialData: data }, { children: [_jsx(ScrollRestoration, {}), _jsx("div", __assign({ className: "text-md-reg-m md:text-md-reg-d" }, { children: _jsx(Outlet, {}) }))] }))) : (_jsxs("div", __assign({ className: "flex flex-col min-h-screen bg-squash" }, { children: [_jsx(Header, {}), _jsx("div", __assign({ className: "w-full flex-grow flex items-center justify-center" }, { children: _jsx("img", { src: unboxingDryIceGifSrc, alt: "Loading", width: "200", height: "200" }) }))] })))] }));
};
export default ProfileLayout;
